// Journal of the page for «Сообщить об ошибке»: the last console errors and warnings, uncaught
// errors, failed requests and page changes, in memory of this tab only. Never request bodies,
// tokens or query strings (search texts): a request is its method, path and status.
const MAX_ENTRIES = 100
const MAX_MESSAGE = 1000
const entries = []
let installed = false

function stamp() {
  return new Date().toISOString().slice(11, 23)
}

function text(value) {
  if (value instanceof Error) return `${value.name}: ${value.message}${value.stack ? '\n' + value.stack : ''}`
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value)
  } catch (e) {
    return String(value)
  }
}

export function addEntry(level, message) {
  entries.push({ time: stamp(), level, message: String(message).slice(0, MAX_MESSAGE) })
  if (entries.length > MAX_ENTRIES) entries.splice(0, entries.length - MAX_ENTRIES)
}

export function getEntries() {
  return entries.slice()
}

function pathOnly(url) {
  if (!url) return ''
  try {
    return new URL(url, window.location.origin).pathname
  } catch (e) {
    return String(url).split('?')[0]
  }
}

// axios: failed requests and their timing
export function watchClient(client, name) {
  client.interceptors.request.use(config => {
    config.metadata = { started: Date.now() }
    return config
  })
  client.interceptors.response.use(
    response => response,
    error => {
      const config = error.config || {}
      const took = config.metadata ? `${Date.now() - config.metadata.started} мс` : ''
      const status = error.response ? error.response.status : (error.code || 'нет ответа')
      const detail = error.response && error.response.data && error.response.data.detail
      addEntry('request', `${name} ${(config.method || '').toUpperCase()} ${pathOnly(config.url)} → ${status} ${took}` +
        (detail ? ` (${text(detail).slice(0, 300)})` : ''))
      return Promise.reject(error)
    }
  )
}

export function installClientLog(router) {
  if (installed) return
  installed = true
  for (const level of ['error', 'warn']) {
    const original = console[level].bind(console)
    console[level] = (...args) => {
      addEntry(level, args.map(text).join(' '))
      original(...args)
    }
  }
  window.addEventListener('error', e => addEntry('error', e.error ? text(e.error) : `${e.message} (${e.filename}:${e.lineno})`))
  window.addEventListener('unhandledrejection', e => addEntry('error', 'Unhandled promise: ' + text(e.reason)))
  if (router) router.afterEach(to => addEntry('page', to.path))
}
